// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__35QqT","resendInfoText":"OnGoingPaymentBox_resendInfoText__FaK9L"};